import { render, staticRenderFns } from "./CakeshopDetail.vue?vue&type=template&id=79bed264&scoped=true&"
import script from "./CakeshopDetail.vue?vue&type=script&lang=js&"
export * from "./CakeshopDetail.vue?vue&type=script&lang=js&"
import style0 from "./CakeshopDetail.vue?vue&type=style&index=0&id=79bed264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bed264",
  null
  
)

export default component.exports